// Extend the Window interface to include process
declare global {
  interface Window {
    process?: any;
    global?: any;
  }
}

// Polyfill for Node.js process in browser environment
if (typeof window !== 'undefined' && !window.process) {
  window.process = {
    env: {
      NODE_ENV: import.meta.env.MODE,
    }
  };
}

// Polyfill for global in browser environment
if (typeof window !== 'undefined' && !window.global) {
  window.global = window;
}

export {}; 